(function (global, factory) {
	if('object' == typeof exports && 'object' == typeof module) {
        module.exports = factory()
    /*eslint no-undef: */
    } else if ('function' == typeof define && define.amd) {
        define([], factory)
    } else if('object' == typeof exports) {
        exports.N = factory()
    } else {
        global.N = factory()
    }
})(this, function () {
    var d = document
    var w = window
    var root = d.documentElement
    function qs(query, finder) {
        return (finder || d).querySelector(query)
    }
    function qsa(query, finder) {
        return Array.from((finder || d).querySelectorAll(query))
    }
    function on(element, event, callback) {
        element.addEventListener(event, callback, false)
    }
    function off(element, event, callback) {
        element.removeEventListener(event, callback, false)
    }
    function triggerEvent(el, event, opt) {
        var custom = new CustomEvent(event, opt || {})
        for(let key in opt) {
        custom[key] = opt[key]
        }
        return el.dispatchEvent(custom)
    }
    function Dropdown(element) {
        element.neu = element.neu || {}
        element.neu.dropdown = this
        var cleanUp
        var isUpper = element.matches('.n-dropup')
        var isEnd = element.matches('.n-dropend')
        var toggler = qs('.n-dropdown-toggle', element)
        var menu = qs('.n-dropdown-menu', element)
        var predecessor = element.parentElement.closest('.n-dropdown')
        var media = w.matchMedia("(max-width: 400px)")
        var autoFlip = function () {
            var rect = toggler.getBoundingClientRect()
            if(!media.matches) {
                var isHighBlow = 0 > (predecessor ? (rect.top + rect.height) - menu.clientHeight : rect.top - menu.clientHeight)
                var isLowBlow = root.clientHeight < (predecessor ? rect.top + menu.clientHeight : rect.top + rect.height + menu.clientHeight)  
                if(isHighBlow && isLowBlow) {
                    element.classList.remove("n-dropup")
                    element.classList.add("n-dropup-stack")
                    menu.style.top = (rect.top * -1) + "px"
                } else {
                    menu.style.top = null
                    element.classList.remove("n-dropup-stack")
                    if(isUpper) {
                        element.classList[isHighBlow ? 'remove' : 'add']("n-dropup") 
                    } else {
                        element.classList[isLowBlow ? 'add' : 'remove']("n-dropup") 
                    }
                }
                var isLeftBlow = 0 > rect.left - menu.clientWidth
                var isRightBlow = root.clientWidth < rect.left + rect.width + menu.clientWidth
                if(isLeftBlow && isRightBlow) {
                    element.classList.remove("n-dropend")
                    element.classList.add("n-dropend-stack")
                    menu.style.left = (rect.left * -1) + "px"
                } else {
                    menu.style.left = null
                    element.classList.remove("n-dropend-stack")
                    if(isEnd) {
                        element.classList[isLeftBlow ? 'remove' : 'add']("n-dropend") 
                    } else {
                        element.classList[isRightBlow ? 'add' : 'remove']("n-dropend") 
                    }
                }
            }
        }
        var show = function () {
            if(predecessor) {
                if(!predecessor.matches('.n-dropdown.show')) {
                    var pi = predecessor.neu.dropdown
                    pi && pi.show()
                }
                var prevshow = qs('.show', predecessor)
                if(prevshow && prevshow !== element) {
                    var pri = prevshow.neu.dropdown
                    pri && pri.close()
                }
            }
            menu.style.display = "block"
            element.classList.add("transition")
            
            autoFlip()

            toggler.setAttribute("aria-expanded", true)
            triggerEvent(element, 'show.n.dropdown')
            setTimeout(function() {
                element.classList.add("show")
            }, 50)
            clearTimeout(cleanUp)
            cleanUp = setTimeout(function() {
                triggerEvent(element, 'shown.n.dropdown')
                element.classList.remove("transition")
            }, 750)
        }
        var close = function () { 
            var hasShowed = qs('.n-dropdown.show', element)
            if(hasShowed) {
                var hi = hasShowed.neu.dropdown
                hi && hi.close()
            }
            toggler.setAttribute("aria-expanded", false)
            triggerEvent(element, 'hide.n.dropdown')
            element.classList.remove("show")
            element.classList.add("transition") 
            clearTimeout(cleanUp)
            cleanUp = setTimeout(function() {
                triggerEvent(element, 'hidden.n.dropdown')
                element.classList.remove("transition")
                menu.style.display = "none"
            }, 750) 
        }
        var handlers = {
            toggler: function (e) {
                if(predecessor) {
                    e.stopPropagation()
                } 
                e.preventDefault()
                if(element.matches('.show')) {
                    close()
                } else {
                    show()
                }
            },
            element: function (e) {
                if(!element.matches('.show')) return
                if(predecessor && e.target === element) {
                    e.stopPropagation()
                }
                if(element.dataset.interactive === 'true') {
                    if(e.target === element) {
                        close()
                    }
                } else if(e.target !== toggler) {
                    close()
                }
            },
            media: function () {
                if(!media.matches && element.matches(".show")) {
                    setTimeout(function() {
                        autoFlip()
                    }, 100)
                }
            }
        }
        var init = function () {
            on(toggler, 'click', handlers.toggler)
            on(element, 'click', handlers.element)
            media.addListener(handlers.media)
        }
        init()
        this.destroy = function () {
            delete element.neu.dropdown
            off(toggler, 'click', handlers.toggler)
            off(element, 'click', handlers.element)
            media.removeListener(handlers.media)
        }
        this.show = function () {
            show()
        }
        this.close = function () {
            close()
        }
    }

    function Modal(element) {
        element.neu = element.neu || {}
        element.neu.modal = this
        var cleanUp
        var togglers = qsa('[href="#'+element.id+'"], [data-modal="#'+element.id+'"]')
        var show = function () {
            triggerEvent(element, 'show.n.modal')
            element.style.display = "block"
            element.classList.add("transition")
            d.body.classList.add("n-modal-shown")
            setTimeout(() => {
                element.classList.add("show")
            }, 50)
            clearTimeout(cleanUp)
            cleanUp = setTimeout(() => {
                triggerEvent(element, 'shown.n.modal') 
                element.classList.remove("transition")
            }, 800)
        }
        var close = function () { 
            triggerEvent(element, 'hide.n.modal')
            element.classList.remove("show")
            element.classList.add("transition")
            clearTimeout(cleanUp)
            cleanUp = setTimeout(() => {
                triggerEvent(element, 'hidden.n.modal')
                d.body.classList.remove("n-modal-shown")
                element.classList.remove("transition")
                element.style.display = "none"
            }, 800) 
        }
        var handlers = {
            toggler: function (e) {
                e.preventDefault()
                if(element.matches('.show')) {
                    close()
                } else {
                    show()
                }
            },
            element: function (e) {
                if(element.matches('.show') && ((e.target === element && element.dataset.backdrop !== "static") 
                || e.target.dataset.dismiss === "modal")) { 
                    close()
                }
            }
        }
        var init = function () {
            togglers.forEach(function(toggler) {
                on(toggler, 'click', handlers.toggler)
            }) 
            on(element, 'click', handlers.element)
        }
        init()
        this.destroy = function () {
            delete element.neu.modal
            togglers.forEach(function(toggler) {
                off(toggler, 'click', handlers.toggler)
            })
            off(element, 'click', handlers.element)
        }
        this.show = function () {
            show()
        }
        this.close = function () {
            close()
        }
    }

    function Collapse(element) {
        element.neu = element.neu || {}
        element.neu.collapse = this
        var cleanUp
        var togglers = qsa('[href="#'+element.id+'"], [data-collapse="#'+element.id+'"]')
        var parent = qs(element.dataset.parent)
        var ending = function (isClosed) {
            togglers.forEach((toggler) => toggler.setAttribute("aria-expanded", !isClosed))
            clearTimeout(cleanUp)
            cleanUp = setTimeout(function () { 
                triggerEvent(element, (isClosed ? 'hidden' : 'shown') + '.n.collapse')
                element.classList.remove("transition")
                element.style.display = element.style.height = null
            }, 700)
        }
        var show = function () { 
            if(element.matches('.show')) return
            element.style.display = "block"
            triggerEvent(element, 'show.n.collapse')
            element.style.height = "0"
            element.classList.add("transition")
            setTimeout(function () { 
                element.classList.add("show") 
                element.style.height = element.scrollHeight + "px"
            }, 50)
            ending(false)
        }
        var close = function () { 
            if(!element.matches('.show')) return
            element.style.display = "block"
            triggerEvent(element, 'hide.n.collapse')
            element.style.height = element.offsetHeight + "px" 
            element.classList.add("transition")
            setTimeout(function () {
                element.classList.remove("show") 
                element.style.height = "0"
            }, 50)
            ending(true)
        }
        var handlers = {
            toggler: function (e) {
                e.preventDefault()
                var trigger = e.target
                if(parent) {
                    const prevShow = qs("[data-parent].show", parent)
                    if(prevShow && prevShow !== element) {
                        var pi = prevShow.neu.collapse
                        pi && pi.close()
                    }   
                }
                var isShow = element.matches('.show')
                if(isShow) {
                    close()
                } else {
                    show()
                }
                element.ontransitionend = function () { 
                    trigger.blur() 
                    element.ontransitionend = null
                }
            }
        }
        var init = function () {
            togglers.forEach(function(toggler) {
                on(toggler, 'click', handlers.toggler)
            }) 
        }
        init()
        this.destroy = function () {
            delete element.neu.collapse
            togglers.forEach(function(toggler) {
                off(toggler, 'click', handlers.toggler)
            })
        }
        this.show = function () {
            show()
        }
        this.close = function () {
            close()
        }
    }

    return {
        dropdown: {
            getInstance(element) {
                if(!(element.neu && element.neu.dropdown)) {
                    new Dropdown(element)
                }
                return element.neu.dropdown
            }
        },
        modal: {
            getInstance(element) {
                if(!(element.neu && element.neu.modal)) {
                    new Modal(element)
                }
                return element.neu.modal
            }
        },
        collapse: {
            getInstance(element) {
                if(!(element.neu && element.neu.collapse)) {
                    new Collapse(element)
                }
                return element.neu.collapse
            }
        }
    }
})